
import './one_to_one_message.less';
import './chat.less';

import React, {PropTypes} from 'react';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import authActions from '../auth/auth_actions';
import messageActions from './messages_action';
import CONSTANTS from '../common_constants';
import moment from 'moment';
import ReactDOM from 'react-dom';
import validate from '../util/validate';
import {Link, browserHistory} from 'react-router';
import classNames from 'classnames';
import SetPickupAndDeliveyTime from './pickup_delivery';
import ShowError from '../components/error/show_error';
import AgentInfo from './agent_widget';
import shipmentActions from '../shipment/shipment_actions';
import MediaQuery from 'react-responsive';
import './messages.less';
import DashBoardHeader from '../header_dashboard/dashboard_header';
import LogoutPopUp from '../components/logoutPopUp/logout_pop_up';
import LoggedinFooter from '../footer/loggedin_footer';
import {join} from '../util/common';
import $ from 'jquery';

class FromMessage extends React.Component{
  constructor(props){
    super(props);
  }
  render(){
    const {chat} = this.props;
    const createdTime = moment(chat.timestamp).calendar();

    let messageStatus;
    let firebaseTime = moment(chat.firebaseTime).unix()*1000;
    if(firebaseTime<chat.messageTime){
      messageStatus = "Read";
    }
    else{
      messageStatus = "Sent";
    }
    return(
        <div className = "from-message-wrap message-wrap">
          <div className = "messsage-info-wrap">
            <div className = "message-content from-message-content">
              {chat.message}
            </div>
            <div className = "user-img-wrap">
              <div className="user-img" style = {{"backgroundImage": 'url("' + chat.imageUrl + '")'}}></div>
            </div>
          </div>
          <div className = "message-created-time">{createdTime}</div>
          <div className = "message-status">{messageStatus}</div>
        </div>
    );
  }
}

class ToMessage extends React.Component{
  constructor(props){
    super(props);
  }
  render(){
    const {chat} = this.props;
    const createdTime = moment(chat.timestamp).calendar();

    return(
      <div className = "to-message-wrap message-wrap">
        <div className = "messsage-info-wrap">
          <div className = "user-img-wrap">
            <div className="user-img"
              style = {{"backgroundImage": 'url("' + chat.imageUrl + '")'}}>
            </div>
          </div>
          <div className = "message-content to-message-content">
            {chat.message}
          </div>
        </div>
        <div className = "message-created-time">{createdTime}</div>
      </div>
    );
  }
}

class SendMessage extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      shipmentInfo: props.shipmentInfo,
      message: ""
    }
  }

  inputChange = (name, event) => {
    const value = event.target.value;

    if(value){
      let nameStr = value.trimLeft()
      nameStr = nameStr.trim();
      if(!nameStr || nameStr.length>CONSTANTS.LEAVE_FEEDBACK_TEXT_LIMIT) return false;
    }

    this.setState({message: value});
    this.props.onInputChange();
  }

  onMessageSend = (e) => {
    e.preventDefault();
    const {state,props} = this;
    const paramObj = {'message':state.message};
    this.setState({message: ''});
    props.sendMessage(paramObj);
  }

  // componentWillReceiveProps(newProps){
  //   if (newProps.shipment.shipmentDetails) this.setState({shipment: newProps.shipment.shipmentDetails});
  // }

  render(){
    return(
      <form className = "send-message-wrap" onSubmit = {this.onMessageSend}>
        <input placeholder="Reply"
               className="form-input input-message"
               type="text"
               autoCapitalize="none"
               name="inputMessage"
               autoComplete="off"
               value = {this.state.message}
               onChange={this.inputChange.bind(self, 'message')}/>
      </form>
    )
  }
}

class OneToOneChat extends React.Component {
  constructor(props) {
    super(props);
    this.state ={
      messageTime: '',
      isTyping: false,
      error: '',
      isLoading: false
    }
  }

  viewShipmentDetails = (shipmentId,carrierId) => {
    const {props,state} = this;
    const self = this;
    const {shipmentActions} = this.props;

    self.setState({isLoading: true});

    shipmentActions.viewShipmentDetails(shipmentId,carrierId).then((data) => {
      self.setState({
        error: '',
        shipmentStatusData: data.shipmentStatus,
        shipment: data.shipmentDetails
      }, self.firebaseSignIn(data.token));
    }, (errorRes) => {
      self.setState({isLoading: false, error: errorRes.error}, $("html, body").animate({scrollTop: 0}, 1000))
    });
  }


  firebaseSignIn = (token) => {
    const self = this;
    firebase.auth().signInWithCustomToken(token).then(function(data) {
      // Handle Errors here.
      const errorCode = data.code;
      const errorMessage = data.message;
      if (errorCode === 'auth/invalid-custom-token') {
      } else {
        const userId = firebase.auth().currentUser.uid;
        self.getConversationMessages();
      }
    }, (data) => {
    });
  }

  writeUserMsgToFirebase = (messageObj) => {
    const self = this;
    const messageId = this.getMessageId();
    const time = firebase.database.ServerValue.TIMESTAMP;
    const senderId = self.props.authState.userData.userId;

    const userMsgObj = {
      isShipper: messageObj.isShipper,
      message: messageObj.message,
      timestamp: time,
      senderId,
      isRead: true
    }

    const messageReadObj = {},
          typingIndicatorObj = {};

    messageReadObj[senderId] = time;
    typingIndicatorObj[senderId] = false;

    const userId = firebase.database().ref('/Inbox/' + messageId ).push().getKey();
    firebase.database().ref('/Inbox/' + messageId ).child(userId).set(userMsgObj);

    //Message read object for firebase
    firebase.database().ref('/Inbox/' + messageId ).child("messageRead").set(messageReadObj);
    //Typing indicator
    firebase.database().ref('/Inbox/' + messageId ).child("typingIndicator").update(typingIndicatorObj);
  }

  onInputChange = () => {
    const self = this;
    const messageId = this.getMessageId();
    const senderId = self.props.authState.userData.userId;
    const time = firebase.database.ServerValue.TIMESTAMP;

    const typingIndicatorObj = {},
          messageReadObj = {};
    typingIndicatorObj[senderId] = true;

    messageReadObj[senderId] = time;
    firebase.database().ref('/Inbox/' + messageId ).child("messageRead").set(messageReadObj);

    firebase.database().ref('/Inbox/' + messageId ).child("typingIndicator").update(typingIndicatorObj);
  }

  onSendMessage = (messageObj) => {
    const self = this;
    const {props,state} = this;
    const {messageActions} = this.props;
    const {shipmentStatusData,shipment} = this.state;

    const paramObj ={
      shipmentId: state.shipmentId,
      message: messageObj.message,
      toUserId: shipmentStatusData.carrierId,
      title: shipment.title,
      isShipper: shipmentStatusData.isShipper
    }

    //Carrier to Receiver Chat
    if(state.receiverId) {
      let userId = this.props.authState.userData.userId;

      //logged in user is receiver and chat to carrier
      if(userId === state.receiverId){
        paramObj.toUserId = shipmentStatusData.carrierId;
      }
      else {
        //logged in user is carrier and chat to receiver
        paramObj.toUserId = state.receiverId;
      }
    }
    // Shipper to Carrier Chat
    else{
      let userId = this.props.authState.userData.userId;

      //logged in user is shipper and chat to carrier
      if(userId === shipmentStatusData.shipperId){
        paramObj.toUserId = shipmentStatusData.carrierId;
      }
      else {
        //logged in user is carrier and chat to shipper
        paramObj.toUserId = shipmentStatusData.shipperId;
      }
    }

    messageActions.sendMessage(paramObj).then(() => {
      self.setState({error: ''});
      self.writeUserMsgToFirebase(paramObj);
    }, (errorRes) => {
      self.setState({isLoading: false, error: errorRes.error}, $("html, body").animate({scrollTop: 0}, 1000))
    });
  }

  getFirebaseAuthToken = () => {
    const {props,state} = this;
    const self = this;
    const {messageActions} = this.props;
    //self.setState({isLoading: true});
    messageActions.getFirebaseAuthToken().then((data) => {
      self.firebaseSignIn(data.token);
    }, (errorRes) => {
    });
  }

  getMessageId = () => {
    const {state,props} = this;
    const {shipmentStatusData} = state;

    let userId;
    if(state.receiverId) userId = state.receiverId;
    else if(shipmentStatusData.isReceiver) userId = props.authState.userData.userId;
    else userId = shipmentStatusData.shipperId;

    return userId + shipmentStatusData.carrierId + shipmentStatusData.shipmentId;
  }

  getUserMessage = (chatMessages) => {
    const self = this;
    const {state,props} = self;
    const {userData} = props.authState;
    const {shipment, shipmentStatusData} = state;
    const userId = userData.userId; // Logged in User Id
    let carrierId = state.carrierId; // Carrier From the threads

    const firebaseTime = firebase.database.ServerValue.TIMESTAMP;

    let userInfo = {};
    let updatedInfo = [];

    for (var key in chatMessages) {
      if (chatMessages.hasOwnProperty(key)) {
        if(chatMessages[key].senderId === userId) {
          userInfo.isFrom = true;
          userInfo.messageTime = state.messageTime;
          userInfo.firebaseTime = firebaseTime;
          userInfo.imageUrl = userData.profileImageUrl || "../../../public/images/user_placeholder.svg";
          let userdata = Object.assign({},userInfo,chatMessages[key]);
          updatedInfo.push(userdata);
        }
        else if(chatMessages[key].senderId){
          userInfo.isFrom = false;
          userInfo.messageTime = state.messageTime;
          userInfo.firebaseTime = firebaseTime;
          userInfo.imageUrl = shipmentStatusData.profileImgUrl || "../../../public/images/user_placeholder.svg";
          let userdata = Object.assign({},userInfo,chatMessages[key]);
          updatedInfo.push(userdata);
        }
      }
    }
    // self.setState({conversationChat: updatedInfo});
    return updatedInfo;
  }

  getToUserMessageStatus = (messageReadTime,typingIndicator) => {
    const self = this;
    const {props,state} = this;
    const {userId} = props.authState.userData;
    // const {messageReadTime,typingIndicator} = state;
    let messageTime,isTyping;

    for (var key in messageReadTime) {
      if (messageReadTime.hasOwnProperty(key)) {
        if(key!= userId) {
          messageTime = messageReadTime[key];
        }
      }
    }

    for (var key in typingIndicator) {
      if (typingIndicator.hasOwnProperty(key)) {
        if(key!= userId) {
          isTyping = typingIndicator[key];
        }
      }
    }
    return({
      messageReadTime: messageTime,
      isTyping: isTyping
    });
  }

  getConversationMessages = () => {
    const self = this;
    const messageId = this.getMessageId();
    const senderId = self.props.authState.userData.userId;
    const time = firebase.database.ServerValue.TIMESTAMP;

    const typingIndicatorObj = {},
          messageReadObj = {};

    messageReadObj[senderId] = time;
    typingIndicatorObj[senderId] = false;

    firebase.database().ref('/Inbox/' + messageId).child("typingIndicator").update(typingIndicatorObj);
    firebase.database().ref('/Inbox/' + messageId).child("messageRead").update(messageReadObj);

    firebase.database().ref('/Inbox/' + messageId ).on('value', function(data) {
      // self.setState({isLoading: false});
      const chatMessages = data.val();
      const statusObj = self.getToUserMessageStatus(chatMessages.messageRead,chatMessages.typingIndicator);//Update message read time and isLoading
      const updatedChatMessage = self.getUserMessage(chatMessages);
      self.setState({
        conversationChat: updatedChatMessage,
        chatMessages: chatMessages,
        messageReadTime: chatMessages.messageRead,
        typingIndicator: chatMessages.typingIndicator,
        messageTime: statusObj.messageReadTime,
        isTyping:statusObj.isTyping,
        isLoading: false
      })
    });
  }

  componentDidMount(){
    const {props,state} = this;
    const shipmentId = props.params.shipmentId;
    const carrierId = props.params.carrierId;
    const receiverId = props.location.query.receiverId;

    const backTo = props.location.query.backTo;

    backTo
    this.setState({
      carrierId,
      shipmentId,
      receiverId,
      backTo
    });

    this.viewShipmentDetails(shipmentId,carrierId);
  }

  getAgentInfo = () => {
    const {shipmentStatusData,shipment} = this.state;
    let agentInfo,agentType, info ={};

    if(this.state.receiverId && shipment){
      agentInfo = shipment.recipientInfo;
      agentType = "RECEIVER";
    }
    else if((shipmentStatusData && shipment && (shipmentStatusData.shipmentStatus === 3))){
      info.profileImgUrl = shipmentStatusData.profileImgUrl || "../../public/images/user_placeholder.svg";
      info.name = shipmentStatusData.name;
      info.email = shipmentStatusData.email;
      info.totalNoOfRatings = shipmentStatusData.totalNoOfRatings;
      info.averageRating = shipmentStatusData.averageRating;
      info.userId = shipmentStatusData.carrierId;
      info.phoneNo = '';
      info.agentType = 'CARRIER';
      agentInfo = info;
    }
    else if(shipmentStatusData && shipment && (shipment.isShipper || shipment.isReceiver)){
      agentInfo = shipment.carrierInfo;
      agentType = "CARRIER";
    }
    else if(shipmentStatusData && shipment && !shipment.isShipper){
      agentInfo = shipment.shipperInfo;
      agentType="SHIPPER";
    }

    if(shipment && shipmentStatusData){
      if(info.hasOwnProperty('name')) return info;
      return({
        imageUrl: agentInfo.profileImgUrl || "../../public/images/user_placeholder.svg",
        name: agentInfo.name,
        email: agentInfo.email,
        phoneNo: agentInfo.phoneNumber || "",
        totalNoOfRatings: agentInfo.totalNoOfRatings,
        averageRating: agentInfo.averageRating,
        userId: agentInfo.userId,
        shipmentId: shipment.shipmentId,
        agentType: agentType
      });
    }
  }

  scrollToBottom = () => {
    const node = ReactDOM.findDOMNode(this.messagesEnd);
    if(node) node.scrollIntoView({behavior: "smooth"});
  }

  componentDidUpdate = () => {
    this.scrollToBottom();
  }

  componentWillUnmount = () => {
    const {state,props} = this;
    if(state.shipment){
      const messageId = this.getMessageId();
      firebase.database().ref('/Inbox/' + messageId).off('value');
    }
  }

  updateErrorState = (error) => {
    this.setState({error: error});
  }

  shouldComponentUpdate = () => {
    return true;
  }

  render() {
    const self = this;
    const {props, state} = this;
    const {shipment, shipmentStatusData} = state;
    const {userData} = props.authState;
    let sessionValid = true ;

    if("sessionValid" in props.authState.userData){
      sessionValid = props.authState.userData.sessionValid;
    }

    let user = {
      name: '',
      imageUrl: '',
      isVerified: '',
      creditAmount: ''
    };

    if(props.authState) {
      user.name = userData.name;
      user.imageUrl = userData.profileImageUrl;
      user.isVerified = userData.isVerified;
    }

    let agentComponent;
    if(shipmentStatusData && shipment && (shipmentStatusData.shipmentStatus === 3)){
      agentComponent =  <AgentInfo shipment = {state.shipment}/>;
    }
    else if(state.shipment){
      agentComponent = <AgentInfo agentInfo = {this.getAgentInfo()} shipment = {state.shipment}/> ;
    }

    let backUrl;
    if(state.backTo === "track-shipment"){
      backUrl = "/track-shipment/" + state.shipmentId;
    }
    else if(state.backTo === "carrier"){
       backUrl = "/inbox/i-am-carrying"
    }
    else if(state.backTo === "receiver"){
       backUrl = "/inbox/i-am-receiving"
    }
    else{
       backUrl = "/inbox/i-am-shipping";
    }

    return (
      <div className = "message-page">
        <DashBoardHeader user={user} logout={this.logout} />
        {state.error && <ShowError errorMessage = {state.error} />}
        {state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
        <div className = "wrapper back-wrapper">
          <Link to={backUrl}>
            <div className="back-section"><span className="icon-icn_back"></span><span className="back-content">Back</span></div>
          </Link>
          {
            state.shipment && <MediaQuery query='(max-width: 767px)'>
              <Link to = {"/shipment/" + state.shipment.shipmentId}>
                <div className = "view-details">View Details</div>
              </Link>
            </MediaQuery>
          }
        </div>
        <div className = "wrapper message-info-wrap">
          {agentComponent}
          <div className = "chat-info-wrp">
            {
              state.shipmentStatusData &&
                <SetPickupAndDeliveyTime
                  carrierId={state.carrierId}
                  shipmentStatusData={state.shipmentStatusData}
                  shipmentInfo = {state.shipment}
                  updateErrorState = {this.updateErrorState}
                />
            }
            <div className = "one-to-one-chat-section">
              { state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
              <div className = "message-list">
                {
                   (state.conversationChat && state.conversationChat.length>0)&&
                     state.conversationChat.map((chat,key) => {
                      if(chat.isFrom) return <FromMessage chat={chat} key={key} />
                      return <ToMessage chat={chat} key={key} />
                    })
                }
                { state.isTyping && <div className = "typing-indicator">typing...</div>}
                <SendMessage
                  shipmentInfo={state.shipmentInfo}
                  sendMessage = {this.onSendMessage}
                  onInputChange = {this.onInputChange}
                />
                <div className = "message-scroll-wrap"
                    ref={(el) => { this.messagesEnd = el; }}>
                </div>
              </div>
            </div>
          </div>
        </div>
        <LoggedinFooter />
      </div>
    );
  }
}

OneToOneChat = connect((state) => {
  return {
    authState: state.app.auth,
    shipment: state.app.shipment
  }
}, (dispatch) => {
  return {
    shipmentActions: bindActionCreators(shipmentActions, dispatch),
    authActions : bindActionCreators(authActions, dispatch),
    messageActions: bindActionCreators(messageActions, dispatch)
  }
})(OneToOneChat);

module.exports = OneToOneChat;



// WEBPACK FOOTER //
// app/messages/one_to_one_message.jsx